import config from '../../config';
import { navigateToExternal } from '../../core/util';

export const redirectToAPP = applicationID => {
  const url = `${config(
    'clxUrl'
  )}/usis/activeplus-portfolios/public/rtq/q1?nru=${config(
    'returnUrlPrefix'
  )}personal-investing/tools/nasu/return-journey/welcome?applicationID=${applicationID}`;

  navigateToExternal(url);

  return url;
};
